/**
 * @generated SignedSource<<bf067655b68acc92a3e246fb51a10781>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type RoleArchiveMutation$variables = {
  id: number;
};
export type RoleArchiveMutation$data = {
  readonly archiveRole: {
    readonly role: {
      readonly active: boolean;
      readonly id: number;
      readonly name: string;
    } | null | undefined;
  };
};
export type RoleArchiveMutation = {
  response: RoleArchiveMutation$data;
  variables: RoleArchiveMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "RoleChangedResult",
    "kind": "LinkedField",
    "name": "archiveRole",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "roles",
        "kind": "LinkedField",
        "name": "role",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "active",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RoleArchiveMutation",
    "selections": (v1/*: any*/),
    "type": "mutation_root",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RoleArchiveMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "15a673bac2026bdf6886835b6b7b9aa8",
    "id": null,
    "metadata": {},
    "name": "RoleArchiveMutation",
    "operationKind": "mutation",
    "text": "mutation RoleArchiveMutation(\n  $id: Int!\n) {\n  archiveRole(id: $id) {\n    role {\n      id\n      name\n      active\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "77103b66db42665afe557ad418462bd5";

export default node;
